// ConfirmPopupWindow.js

import { Box, Text, Button, Layer, Image, Header } from "grommet";
import { useState, useEffect, useContext, useRef } from "react";
import useTrapFocus from "../Utils/useTrapFocus";
  
const ConfirmPopupWindow = (props) => {

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    return (
            <Layer
              id="confirm-msg"
              ref={modalRef}
              tabIndex="-1"
              position="center"
              modal
              style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
              }}
              onEsc={props.onClose}
              onClickOutside={() => {}}
            >

            <Box 
                overflow='auto'
                pad="small" 
                gap="small" 
                width="medium"  
                background="white"  
                
                style={{
                    position: 'relative',
                    margin: 'auto', // Center horizontally and vertically
                }}
            >        
                <Box
                    pad="small" // Padding to create space for the white border
                    background="#ebf6fa" // White border
                    border={{ color: "brand"}}
                    >        
              {/* <Box pad="small" margin="small" gap="small" width="medium"  border={{ color: "brand"}}> */}

              <Box style={{position:"relative"}}>
                    <Header margin="none" background="#c0e0ed" pad="small" height="xxsmall" justify="around">
                        <Text alignSelf="start" color="brand" size="large"  align="center" >
                            <strong>Confirm</strong>
                        </Text>
                    </Header>
                    <Box height="xsmall" width="xsmall"  
                        style={{position:"absolute", right: "3%", top: "15px"}}
                        right="0px"
                        >
                            <Image
                                size="contain"
                                src="Grape.png"                                  
                            />
                    </Box>                 
                </Box>

                <Box align="center" margin={{top: 'medium'}}>
                    <Text  color="brand" margin="large" textAlign="center" ><span style={{whiteSpace: 'pre-line'}}><strong>{props.msg}</strong></span></Text>
                </Box>                
                <Box
                  as="footer"
                  gap="small"
                  direction="row"
                  align="center"
                  justify="center"
                  pad={{ top: 'medium', bottom: 'small' }}
                >
                  <Button
                    label={
                      <Text color="white">
                        <strong>Confirm</strong>
                      </Text>
                    }
                    onClick={props.onConfirm}
                    primary
                   
                  />
                  <Button
                    label={
                      <Text color="brand">
                        <strong>Cancel</strong>
                      </Text>
                    }
                    onClick={props.onClose}
                    secondary                   
                  />                                 
                </Box>
                </Box>
              </Box>
            </Layer>
    )
}

export default ConfirmPopupWindow;